module.exports = __webpack_public_path__ + "img/main-mob.e4b58452.svg";